import { Patient } from '@dreryk/egabinet-patient-frontend-api';

import { useTranslate } from '@dreryk/react-common';
import { LabeledLoader, LoaderSize } from '@dreryk/react-components';

import { FormSectionHeader } from '../../common/FormSectionHeader';
import { patientConsentsAndAuthorizationsTranslationKeys } from '../../translations';

import { useMedicalDataAccessAuthorization } from './MedicalDataAccessAuthorizationPanel.hooks';
import { loaderTransition } from './MedicalDataAccessAuthorizationPanel.transitions';
import { MedicalDataAccessAuthorizationTable } from './MedicalDataAuthorizationConsentTable/MedicalDataAccessAuthorizationTable';

export type MedicalDataAccessAuthorizationPanelProps = {
   readonly patientId: Patient['id'];
};

export const MedicalDataAccessAuthorizationPanel = (props: MedicalDataAccessAuthorizationPanelProps): JSX.Element => {
   const { data: medicalDataAccessAuthorization } = useMedicalDataAccessAuthorization(props.patientId);
   const translate = useTranslate();

   if (!medicalDataAccessAuthorization) {
      return (
         <LabeledLoader
            as={'div'}
            in={!medicalDataAccessAuthorization}
            label={patientConsentsAndAuthorizationsTranslationKeys.authorizations.loadingAuthorizations}
            loaderSize={LoaderSize.SMALL}
            {...loaderTransition}
            testId={'loadingAuthorizations'}
         />
      );
   }

   return (
      <div>
         <FormSectionHeader>
            {translate(patientConsentsAndAuthorizationsTranslationKeys.authorizations.accessToMedicalData)}
         </FormSectionHeader>
         <MedicalDataAccessAuthorizationTable data={medicalDataAccessAuthorization} patientId={props.patientId} />
      </div>
   );
};
